import { render, staticRenderFns } from "./TeacherForgotPassword.vue?vue&type=template&id=423af433&scoped=true"
import script from "./TeacherForgotPassword.vue?vue&type=script&lang=js"
export * from "./TeacherForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./TeacherForgotPassword.vue?vue&type=style&index=0&id=423af433&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423af433",
  null
  
)

export default component.exports